import * as React from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation, withRouter } from 'react-router';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import { useEffect, useState } from 'react';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { Card, Col, Row } from 'antd';
import { generateBackLink } from '../../utils/HistoryUtils';
import { updateNavbarState } from '../../actions/navbar_actions';
import SubcontractorEditForm from '../subcontractor_form/SubcontractorEditForm';
import {
	supplierFacilitiesRestCrudThunksForBuyer,
	supplierFacilitiesRestCrudThunksForSupplier,
} from '../../thunks/supplier_facilities_thunks';
const queryString = require('qs');

const DEFAULT_BACK_LINK_TO = (userType) => `/${userType}/contractors/overview/privateNetwork`;
const DEFAULT_BACK_LINK_TEXT = 'Back to Subcontractors';

function SubcontractorEditPage({ getSubcontractor, userType, match, updateNavbar }) {
	const [loading, setLoading] = useState(false);
	const [subcontractorDetail, setSubcontractorDetail] = useState({});

	const { id } = match.params;

	const location = useLocation();
	const history = useHistory();

	useEffect(() => {
		if (id) {
			setLoading(true);
			getSubcontractor(id).then((client) => {
				setSubcontractorDetail(client);
				setLoading(false);
			});
		}
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		if (queryParams.backlinkParams) {
			const { tab, pathName, backLinkText, ...otherParams } = queryString.parse(
				queryParams.backlinkParams
			);
			const finalPath = pathName || DEFAULT_BACK_LINK_TO(userType);
			let backText = backLinkText || DEFAULT_BACK_LINK_TEXT;
			updateNavbar(backText, generateBackLink(finalPath, location));
		} else {
			updateNavbar(
				DEFAULT_BACK_LINK_TEXT,
				generateBackLink(DEFAULT_BACK_LINK_TO(userType), location)
			);
		}
	}, []);

	return loading ? null : (
		<>
			<LogOnMountWithStandardEventProperties eventType="visited subcontractor edit page" />
			<Row style={{ margin: '0.5em -8px' }} gutter={16}>
				<Col span={24}>
					<Card>
						<div>
							<h5 style={{ marginBottom: 24 }}>Edit Subcontractor</h5>
							<SubcontractorEditForm
								formData={subcontractorDetail}
								loading={loading}
								onSuccess={(rec) => history.push(`/${userType}/contractors/detail/${rec.id}`)}
							/>
						</div>
					</Card>
				</Col>
			</Row>
		</>
	);
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getSubcontractor: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? supplierFacilitiesRestCrudThunksForSupplier.readOne(id)
				: supplierFacilitiesRestCrudThunksForBuyer.readOne(id)
		),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SubcontractorEditPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
